@if (items().length <= STEPS_LIMIT_FOR_BULLETS) {
    <p-stepper [value]="activeStep()">
        <p-step-list>
            @for (item of items(); track $index; let i = $index) {
                <p-step [value]="i + 1">
                    <ng-template #content>
                        <div
                            class="h-4 w-4 rounded-full"
                            [ngClass]="{
                                'bg-brand-red text-white':
                                    i <= activeStep() - 1,
                                'bg-gray-500': i > activeStep() - 1,
                            }">
                            &nbsp;
                        </div>
                    </ng-template>
                </p-step>
            }
        </p-step-list>
    </p-stepper>
} @else {
    <p class="text-gray-100 truncate text-center @xl:text-right">
        {{
            'shared.clientProgressHeader.textualStepper'
                | translate
                    : {
                          currentStep: activeStep() + 1,
                          totalSteps: items().length,
                      }
        }}
    </p>
}
